export default __webpack_public_path__ + "static/media/lab.d3b86370.svg";